import { TextField, TextFieldProps } from 'omakase';
import {
  handleBlurFormattedTextField,
  handleChangeFormattedTextField,
  handleFormattedTextFieldEffect,
} from '@tock/shared/ui/forms/formHelpers';
import { toString } from 'es-toolkit/compat';
import { usePrevious } from '@tock/hooks';
import React from 'react';

type FormattedTextFieldOwnProps = {
  filter: InputFilter;
  formatOnChange?: boolean;
};

export type FormattedTextFieldProps = FormattedTextFieldOwnProps & TextFieldProps;

/**
 * Text input that filters text based on a supplied {@link InputFilter}
 */
const FormattedTextField: React.FunctionComponent<FormattedTextFieldProps> = ({
  filter,
  formatOnChange,
  value,
  onChange,
  onBlur,
  ...rest
}) => {
  const [viewValue, setViewValue] = React.useState<string>(
    value && typeof value === 'string' && value.length > 0
      ? filter
        ? toString(filter.formatModelValue(value))
        : ''
      : ''
  );

  const prevValue = usePrevious(value);

  React.useEffect(
    () =>
      handleFormattedTextFieldEffect(value, prevValue, filter, setViewValue, {
        runOnChange: formatOnChange,
      }),
    [filter, formatOnChange, prevValue, value]
  );

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    handleChangeFormattedTextField(event, filter, setViewValue, onChange);

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) =>
    handleBlurFormattedTextField(event, filter, setViewValue, onBlur);

  return (
    <TextField
      value={filter ? viewValue : value}
      {...rest}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
};

export default FormattedTextField;
